import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { PolicyAction, PolicyFormValues } from '../policy-dialog';
import z from 'zod';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';

interface SuspendUserActionProps {
  setValue: UseFormSetValue<PolicyFormValues>;
  watch: UseFormWatch<PolicyFormValues>;
}

export const SuspendUserActionSchema = z.object({
  type: z.literal('Suspend_User'),
  resetDecom: z.string(),
});

export type SuspendUserActionType = z.infer<typeof SuspendUserActionSchema>;

// Type guard to check if an action is SuspendUserActionType
function isSuspendUserAction(
  action: PolicyAction
): action is SuspendUserActionType {
  return action.type === 'Suspend_User';
}

export default function SuspendUserAction({
  setValue,
  watch,
}: SuspendUserActionProps) {
  const actionData = watch('actionData');
  const idx = actionData.map((action) => action.type).indexOf('Suspend_User');
  const actionAtIndex = actionData[idx];
  if (!isSuspendUserAction(actionAtIndex)) {
    return null;
  }

  const currentAction: SuspendUserActionType = actionAtIndex;

  return (
    <Stack sx={{ p: 1 }}>
      <Stack gap={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={currentAction.resetDecom === 'true'}
              onChange={() =>
                setValue(
                  `actionData.${idx}.resetDecom`,
                  currentAction.resetDecom === 'true' ? 'false' : 'true'
                )
              }
            />
          }
          sx={{ width: 'fit-content' }}
          label="Reset Users Decom Status"
        />
      </Stack>
    </Stack>
  );
}
